import { useNavigate } from "react-router-dom";
import { formatDateWithoutTimeTwo } from "../../utilities/helper";
import StyledGridComp from "../StyledGridComp";

const DataCorrectionsGrid = ({
  rowData,
  rowLength,
  page,
  setPage,
  pageSize,
  setPageSize,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      field: "dataCorrectionNumber",
      headerName: "DCF #",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"DCF #"}</div>,
      renderCell: (params) => {
        const dataCorrectionNumber = params.row.dataCorrectionNumber;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/approve-reject-data-corrections", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {dataCorrectionNumber}
          </button>
        );
      },
    },
    {
      field: "approverGroup",
      headerName: "Approve Group",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Approve Group"}</div>,
      renderCell: (params) => {
        const approverGroup = params.row.approverGroup;

        return <span className="data-font">{approverGroup}</span>;
      },
    },
    {
      field: "correctionType",
      headerName: "Correction Type",
      width: 300,
      renderHeader: () => (
        <div className="grid-heading">{"Correction Type"}</div>
      ),
      renderCell: (params) => {
        const correctionType = params.row.correctionType;

        return <span className="data-font">{correctionType}</span>;
      },
    },
    {
      field: "correctionStatus",
      headerName: "correctionStatus",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Status"}</div>,
      renderCell: (params) => {
        const correctionStatus = params.row.correctionStatus;
        return <span className="data-font">{correctionStatus}</span>;
      },
    },
    {
      field: "patientNumber",
      headerName: "Subject",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Subject"}</div>,
      renderCell: (params) => {
        const patientNumber = params.row.patientNumber;
        return <span className="data-font">{patientNumber}</span>;
      },
    },
    {
      field: "site",
      headerName: "Site",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Site"}</div>,
      renderCell: (params) => {
        const site = params.row.site;
        return <span className="data-font">{site}</span>;
      },
    },
    {
      field: "startedDate",
      headerName: "Date Requested",
      width: 200,
      renderHeader: () => (
        <div className="grid-heading">{"Date Requested"}</div>
      ),
      renderCell: (params) => {
        const startedDate = params.row.startedDate;
        return (
          <span className="data-font">
            {formatDateWithoutTimeTwo(startedDate)}
          </span>
        );
      },
    },
  ];

  return (
    <StyledGridComp
      rows={rowData}
      columns={columns}
      page={page}
      setPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      length={rowLength}
    />
  );
};

export default DataCorrectionsGrid;
